import { ApolloCache } from "@apollo/client"

import { evict } from "shared/api/evict"
import { AttachmentTypename } from "shared/types/Attachment"

export function evictAttachment(id: string, cache: ApolloCache<object>) {
  evict({
    cache,
    id,
    typename: AttachmentTypename
  })
}
